import { apiRoutes } from "../../config";
import { api } from "../../utils/lib/api";

export const getAttributesByProduct = async (entId, prodId) => {
  console.log("entId:", entId);
  console.log("prodId:", prodId);
  try {
    const url = `${apiRoutes.ml.products}/${entId}/variant-attributes/${prodId}`;
    console.log("urlasssss:", url);
    return await api.get(url);
  } catch (error) {
    console.log(error);
    throw new Error(error);
  }
};


export const publishVariant = async (entId, variantId, productData) => {
  try {

    const url = `${apiRoutes.ml.products}/${entId}/publish-odoo-variant-to-ml`;

    // Convertir customAttributes => variantAttributes
    const variantAttributes = productData.customAttributes ? 
      productData.customAttributes.map(attr => ({
        id: attr.name || attr.id,
        value_name: attr.value_name
      })) : [];
      console.log("price: productData.price:", productData.price);
      console.log(productData, "ProductData")
    return await api.post(url, {
      odooVariantId: variantId,
      variantAttributes,
      price: productData.price,
      stock: productData.stock
    });

  } catch (error) {
    console.log(error);
    throw new Error(error);
  }
};

export const getSizeGrids = async (entId, compatibleWithAccount = false) => {
  try {
    const url = `${apiRoutes.ml.sizeGrids}`;
    return await api.get(url, {
      params: {
        enterpriseId: entId,
        compatibleWithAccount,
        limit: 100
      }
    });
  } catch (error) {
    console.log(error);
    throw new Error(error); 
  }
};


